export default {
  Macros: 'macros',
  SharedMacros: 'shared',
};
